/*
 * @LastEditTime: 2022-06-30 19:07:12
 */
import React, { Component } from 'react';
import Header from './component/header';
import Banner from './component/banner';
import Content from './component/content';
import Footer from './component/footer';
import './index.less';

/**
 * é¦–é¡µ
 */
class Home extends Component {
    componentDidMount() {
        window._MEIQIA('init');
        document.title = '企业招聘云服务-新华英才'
    }

    render() {
        return (
            <div className="home">
                <Header />
                <Banner />
                <Content />
                <Footer />
            </div>
        );
    }
}

export default Home;